import { ColumnFiltersState, OnChangeFn } from "@tanstack/react-table";
import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { EtpaOrder } from "@/client-admin/types.gen";
import { columns } from "./columns";
import { DataTable } from "./data-table";

type Props = {
  rows: EtpaOrder[];
  columnFilters: ColumnFiltersState;
  onColumnFiltersChange: OnChangeFn<ColumnFiltersState>;
};

export function EtpaOrdersTable({ rows, columnFilters, onColumnFiltersChange }: Props) {
  const rowsWithId = rows.filter((row) => row.id !== null);
  const missingIdCount = rows.length - rowsWithId.length;

  return (
    <div className="grid grid-cols-1 gap-2">
      {missingIdCount > 0 && (
        <Alert variant="destructive">
          <AlertCircle className="h-4 w-4" />
          <AlertDescription className="ml-2">
            ETPA returned {missingIdCount} order{missingIdCount === 1 ? "" : "s"} without an ID (known ETPA race
            condition bug). These orders are not shown in the table.
          </AlertDescription>
        </Alert>
      )}
      <DataTable
        columns={columns}
        data={rowsWithId}
        getRowId={(row) => row.id as string}
        columnFilters={columnFilters}
        onColumnFiltersChange={onColumnFiltersChange}
      />
    </div>
  );
}
